import * as action_types from "./constants";
import { GetClientType, SelectedClientType } from "./types";

export type myCompanyState = {
  propertyListData: {
    loader: boolean;
    data: [] | null;
    count: number;
  };
  propertyDetailData: {
    loader: boolean;
    data: GetClientType | null;
  };
  propertyFormData: {
    category: { label: string; value: string }[];
    clients: SelectedClientType[];
    managers: { label: string; value: string }[];
  };
  clientContactData: [];
};

const initialState: myCompanyState = {
  propertyListData: {
    loader: true,
    data: null,
    count: 0,
  },
  propertyDetailData: {
    loader: true,
    data: null,
  },
  propertyFormData: {
    category: [],
    clients: [],
    managers: [],
  },
  clientContactData: [],
};

type MyCompanyActionType =
  | {
      type: typeof action_types.GET_PROPERTY_LISTING;
      data: { payload: []; loading: boolean; count: number };
    }
  | {
      type: typeof action_types.GET_PROPERTY_DETAIL;
      data: { payload: GetClientType; loading: boolean };
    }
  | {
      type: typeof action_types.PROPERTY_FORM_DATA;
      data: {
        category: { label: string; value: string }[];
        clients: SelectedClientType[];
        managers: { label: string; value: string }[];
      };
    }
  | {
      type: typeof action_types.GET_CLIENT_CONTACT;
      data: [];
    };

const myCompanyReducer = (
  state = initialState,
  action: MyCompanyActionType
): myCompanyState => {
  const { type, data } = action;
  switch (type) {
    case action_types.GET_PROPERTY_LISTING:
      return {
        ...state,
        propertyListData: {
          loader: data?.loading,
          data: data?.payload,
          count: data?.count,
        },
      };

    case action_types.GET_PROPERTY_DETAIL:
      return {
        ...state,
        propertyDetailData: { data: data?.payload, loader: data?.loading },
      };

    case action_types.PROPERTY_FORM_DATA:
      return {
        ...state,
        propertyFormData: data,
      };

    case action_types.GET_CLIENT_CONTACT:
      return {
        ...state,
        clientContactData: data,
      };

    default:
      return state;
  }
};

export default myCompanyReducer;
